import React from "react";
import ReportSearchTable from "../../UI/DataTable/DataTable";
import { CSVLink } from "react-csv";
import Message from '../../components/Message/Message';

import classes from "./ReportingSearchTable.css";

const ReportSearchResult = (props) => {

    const handleLink = () => {
        props.setCsvInfo({message: "File downloaded successfuly"});
    }

    return props.data != null && props.data.length > 0 ? (
      <>
        <div className={classes.buttonDiv}>
          <div className={classes.RowMessage}>
            <Message msgType={"Success"} info={props.csvInfo} />
          </div>
          <CSVLink
            filename={"Admin-Tool-Reporting-Data.csv"}
            data={props.data}
            headers={props.columns}
            className={classes.csvLinkButton}
            onClick={handleLink}
          >
            Export CSV File
          </CSVLink>
        </div>
        <Message msgType={"Success"} />
        <ReportSearchTable
          title="Report Search Results"
          data={props.data}
          columns={props.columns}
        />
      </>
    ) : null;
};

export default ReportSearchResult;
